export default __webpack_public_path__ + "static/media/car2.3d1dd5cb.png";